"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _PopupView = _interopRequireDefault(require("./PopupView"));

var _form_submitted_popup_view = _interopRequireDefault(require("hbars!../templates/form_submitted_popup_view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormSubmittedPopupView = _PopupView.default.extend({
  events: {
    'click .cancel-action': 'cancelClicked'
  },
  initialize: function initialize(options) {
    options = options || {};
    this.elementId = options.elementId || null;

    _PopupView.default.prototype.initialize.call(this, options);
  },
  cancelClicked: function cancelClicked() {
    var thisView = this;
    var parentElement = this.parent && (0, _jquery.default)(this.parent);
    var registrationFormElement = parentElement.find('.js-registration-form');
    registrationFormElement && registrationFormElement.collapse();
    thisView.model.clearForm();
    this.hide();
  },
  sendClicked: function sendClicked() {
    this.hide();
  },
  render: function render() {
    var html = (0, _form_submitted_popup_view.default)(this.model.toJSON());
    this.$el.html(html);
    return this;
  }
});

var _default = FormSubmittedPopupView;
exports.default = _default;